import { fg } from '@atlaskit/platform-feature-flags/fg';

export default {
	get(): boolean {
		return fg('ai_3p_slack_eg_workspace_metadata_enabled');
	},
};
